import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import {
    addLogParams, addLog, addLocalizador, addLocalizadorParams, dataAddLocalizador, addFollowUpParams, addFollowUp,
    getEtiquetasParams, datagetEtiquetas, getEtiquetas, getMotivoAtencionParams, dataMotivoAtencion, getMotivoAtencion,
} from "@/core/api/sigma"
import { useAuthStore } from '@/core/auth/auth.store';
import { diagnosticosyTratamientosByPaisPRD, diagnosticosyTratamientosByPaisQA } from '@/shared/utils/diagnosticosyTratamientosByPais';
import { env } from '@/config/env';
import { clinicaYDoctorByPaisQA, clinicaYDoctorByPaisPRD } from '@/shared/utils/clinicaYDoctorByPais';

//***mirar como manejo el footer porque este no tiene

const VitalsIntroductionPage = () => {
    const [accepted, setAccepted] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { user, setUser } = useAuthStore()
    const [motivos, setMotivos] = useState([]);

    useEffect(() => {
        // Al entrar a la introducción se reinicia el flujo: se limpia el perfil persistido
        sessionStorage.removeItem('vitalsProfile');

        const auxiliar = async () => {
            await handleGetMotivoAtencion(user.cpais);
        }
        auxiliar();

    }, [])

    const handleGetMotivoAtencion = async (cpais: string) => {
        try {

            const pInputMotivo: getMotivoAtencionParams = {
                cpais, xdescripcion: 'signos'//verificar como lo podemos pasar
            }
            //Obtener la etiqueta necesaria
            const motivosResponse: dataMotivoAtencion[] = await getMotivoAtencion(pInputMotivo);
            setMotivos(motivosResponse);

        } catch (error) {
            console.error("Error al añadir seguimiento:", error);
        }
    };


    const handleAccept = async () => {
        if (!loading) {
            setLoading(true);
            if (user.detailsRequest.ccedasegurado || user.detailLocalizador?.tlocaliza === "IS" || user.detailLocalizador?.tlocaliza === "OS") {
                let cdiagnos = '', ctrata = '', cclinica = '', cdoctor = '';
                console.log("env.isProduction " + env.isProduction)

                if (env.isProduction) {
                    ({ cdiagnos, ctrata } = diagnosticosyTratamientosByPaisPRD[user.cpais]);
                    ({ cclinica, cdoctor } = clinicaYDoctorByPaisPRD[user.cpais]);
                } else {
                    ({ cdiagnos, ctrata } = diagnosticosyTratamientosByPaisQA[user.cpais]);
                    ({ cclinica, cdoctor } = clinicaYDoctorByPaisQA[user.cpais]);
                }

                const today = new Date();
                today.setMinutes(today.getMinutes() + 1);

                const day = String(today.getDate()).padStart(2, '0');
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const year = today.getFullYear();
                const hours = String(today.getHours()).padStart(2, '0')
                const minutes = String(today.getMinutes()).padStart(2, '0')

                const dateString = `${day}/${month}/${year}`;
                const timeString = `${hours}:${minutes}`

                const cciaseg = user.detailLocalizador?.cciaseg || user.detailsRequest?.cciaseg
                const ccliente = user.detailLocalizador?.ccliente || user.detailsRequest?.ccliente
                const cplan = user.detailLocalizador?.cplan || user.detailsRequest?.cplan
                const cproducto = user.detailLocalizador?.cproducto || user.detailsRequest?.cproducto
                const policy = user.coverage?.policies?.[0]
                const insured = user.coverage?.insured

                if (!policy || !insured) {
                    console.log("NO MATCH");
                    setLoading(false); // Importante: liberar el loading antes del error
                    throw new Error("No se encontró una póliza coincidente para el usuario. No se puede crear el localizador de signos vitales.");
                }

                let locType = "SV";
                 if (user.detailLocalizador?.tlocaliza === "IS" || user.detailLocalizador?.tlocaliza === "OS") {
                    locType = "SE"
                }

                if (!user.nlocalizaCreated) {
                    const inputAddLocalizador: addLocalizadorParams = {
                        "typeService": "P",
                        "cproducto": cproducto,
                        "cpais": user.cpais,
                        "cciaseg": cciaseg,
                        "ccliente": ccliente,
                        "cplan": cplan,
                        "icita": "1",
                        "tlocaliza": locType,
                        "imotivo": locType,
                        "cdiagnos": cdiagnos,
                        "ctrata": ctrata,
                        "itipodoctit": user.detailLocalizador?.itipodoctit || policy.inactit,
                        "ccedtitu": user.detailLocalizador?.ccedtitu || policy.holderid,
                        "xtitular": user.detailLocalizador?.xtitular || policy.xtitular,
                        "xtitular_ap": user.detailLocalizador?.xtitular_ap || policy.xtitular_ap,
                        "fnacimi_t": user.detailLocalizador?.fnacimi_t || policy.fnacimi_t,
                        "ctipoasistencia": motivos[0]?.ctipoasistencia,
                        "isexo_t": user.detailLocalizador?.isexo_t || policy.isexo_t,
                        "itipoaseg": user.detailLocalizador?.itipoaseg || policy.holdertype,
                        "isexo": user.detailLocalizador?.isexo || insured.gender,
                        "ccedaseg": user.detailLocalizador?.ccedaseg || insured.id,
                        "xnombre": user.detailLocalizador?.xnombre || insured.firstname,
                        "xapellido": user.detailLocalizador?.xapellido || insured.lastname,
                        "fnacimiento": user.detailLocalizador?.fnacimiento || insured.birthdate,
                        "xcel": user.detailLocalizador?.xcel || user.detailsRequest?.xcelular || insured.phone,
                        "xtelefonocel": user.detailLocalizador?.xtlf || user.detailsRequest?.xcelular || insured.phone,
                        "xemail": user.detailLocalizador?.xemail || user.detailsRequest?.xemail || insured.email,
                        "itipodocben": user.detailLocalizador?.itipodocben || insured.idtype,
                        "fcita": dateString,
                        "fhora": timeString,
                        "cdoctor": cdoctor,
                        "cclinica": cclinica,
                        "iestado": "O",
                        "cprocedencia": user.detailLocalizador?.cprocedencia || user.detailsRequest?.cprocedencia,
                        "xdescripcion": "Localizador para toma de signos vitales desde la aplicación web",
                        "creaclave": true
                    }
                    let xmensaje;
                    try {
                        const response: dataAddLocalizador = await addLocalizador(inputAddLocalizador)
                        setUser({
                            ...user, nlocalizaCreated: response.nlocaliza, ccitaCreated: response.ccita,
                            detailLocalizadorCreated: { ...inputAddLocalizador, ...response.localizador }
                        })

                        console.log("Localizador Creado:", { ...inputAddLocalizador, ...response.localizador });

                        xmensaje = (f, h, l) => `Se creó localizador de Signos Vitales No. ${l} el ${f} a las ${h}`
                        await handleAddFollowUp(user.cpais, user.nlocaliza, response.nlocaliza, xmensaje)
                    } catch (error) {
                        console.error("Error al agregar localizador:", error)

                        if (user.detailLocalizador?.tlocaliza === "IS" || user.detailLocalizador?.tlocaliza === "OS") {
                            xmensaje = (f, h, l) => `Sin eventos disponibles para toma de Signos Vitales el ${f} a las ${h}`
                            await handleAddFollowUp(user.cpais, user.nlocaliza, "", xmensaje)
                        }

                        setLoading(false);
                        navigate("/vitalsignslimit", { replace: true });
                        return
                    }
                }
            }

            const inputLog: addLogParams = {
                csistema: "SignosVitales",
                clog: "ACEPTATYC",
                cpais: user.cpais,
                xdato: user.nlocaliza,
                xdescripcion: `El usuario aceptó los términos y condiciones al presionar el botón aceptar. loc ${user.nlocaliza}`
            };

            try {
                await addLog(inputLog);
            } catch (error) {
                console.error("Error al agregar el log:", error);
                setLoading(false);
                return
            }

            navigate("/form", { state: { from: location }, replace: true });
        }
    };

    return (
        <>
            <div className="container-vitals-full">
                <section className="section-vitals form-vitals m-3">
                    <div className="title-vitals mt-5">
                        <i className="icon icon_enlinea_info"></i>
                        Antes de comenzar:
                    </div>

                    <span className="text-vitals">
                        Deberás completar algunos datos para obtener resultados orientativos sobre tu salud y luego realizarás el escaneo con la cámara de tu dispositivo.
                    </span>
                    <span className="text-vitals">
                        Ten en cuenta que este chequeo <b>no sustituye una evaluación médica</b>.
                    </span>

                    <div className="checkbox-control vitals">
                        {/* <input
                            type="checkbox"
                            className="vitals-accent-color"
                            id="terms"
                            checked={accepted}
                            onChange={(e) => setAccepted(e.target.checked)}
                        /> */}
                        <label htmlFor="terms">
                            <span>
                                Al presionar “Aceptar”, confirmas que has leído y comprendido los <br />{" "}
                                <a href="https://files.sdsigma.com/signosVitales/terminos_y_condiciones_signos_vitales_1.pdf" target="_blank" className="primary-link-btn" rel="noopener noreferrer">
                                    Términos, condiciones y consentimiento informado
                                </a>{" "}
                                y la{" "}
                                <a href="https://corporativo.sdsigma.com/policy?policy=tratamiento​" target="_blank" className="primary-link-btn" rel="noopener noreferrer">
                                    Política de tratamiento de datos
                                </a>{" "}
                                y que estás de acuerdo.
                            </span>
                        </label>
                    </div>

                    <button
                        className="mb-5 btn vitals-primary"
                        onClick={handleAccept}
                        disabled={loading}
                    >
                        {loading ? (
                            <span className="btn-loading">
                                <img src="/img/cargando.gif" alt="Loading..." className="cargando-gif" />
                            </span>
                        ) : (
                            "Aceptar"
                        )}
                    </button>
                    {/* <button
                        className="mb-5 btn vitals-primary"
                        onClick={handleAccept}
                        disabled={!accepted || loading}
                    >
                        {loading ? (
                            <span className="btn-loading">
                                <img src="/img/cargando.gif" alt="Loading..." className="cargando-gif" />
                            </span>
                        ) : (
                            "Aceptar"
                        )}
                    </button> */}

                </section>
                <div className='reserved'>Derechos reservados</div>

            </div>
        </>
    );
};

const handleAddFollowUp = async (
    cpais: string,
    nlocaliza: string,
    nlocalizaCreated: string,
    mensajeBuilder: (fecha: string, hora: string, localizador: string) => string) => {
    try {

        const pInputEtiquetas: getEtiquetasParams = {
            cpais, xdescripcion: 'información'
        }
        //Obtener la etiqueta necesaria
        const etiquetas: datagetEtiquetas[] = await getEtiquetas(pInputEtiquetas);

        if (!etiquetas.length) return;

        // Preparar el mensaje formateado
        const ahora = new Date();
        const fecha = ahora.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
        const hora = ahora.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: false });
        const mensaje = mensajeBuilder(fecha, hora, nlocalizaCreated);

        // Enviar el seguimiento
        const params: addFollowUpParams = {
            cpais, nlocaliza, xdetalle: mensaje,
            cetiqueta: etiquetas[0].cetiqueta,
            cusuario: '9999999999'
        };

        await addFollowUp([params]);
    } catch (error) {
        console.error("Error al añadir seguimiento:", error);
    }
};

export { VitalsIntroductionPage };